import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=429003c2&scoped=true&lang=pug&"
import script from "./InformationModal.vue?vue&type=script&lang=js&"
export * from "./InformationModal.vue?vue&type=script&lang=js&"
import style0 from "./InformationModal.vue?vue&type=style&index=0&id=429003c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429003c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
